import { render, staticRenderFns } from "./Resellers.vue?vue&type=template&id=003b66a9&scoped=true&"
import script from "./Resellers.vue?vue&type=script&lang=js&"
export * from "./Resellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003b66a9",
  null
  
)

export default component.exports